import { pick } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectExpressionsRaw = (state: RootState) => state.site.expressions;

function buildExpressionsCollection(
  expressions: RootState['site']['expressions'],
  names?: string[]
) {
  return !names?.length ? expressions : pick(expressions, names);
}

export const selectExpressions = createSelector(
  [selectExpressionsRaw, (_state: RootState, names?: string[]) => names],
  buildExpressionsCollection
);
